import React from 'react';
import { connect } from 'react-redux';
import { isDialogActive, getRouteQuery, createFilePathObject } from '../selectors';
import { EDIT_INFO_IMAGE_DIALOG } from '../consts';
import EditInfoImageDialog from './EditInfoImageDialog';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

export default connectWithRouter(
  (state, props) => ({
    open: isDialogActive(state, EDIT_INFO_IMAGE_DIALOG),
    file: createFilePathObject(getRouteQuery(state).images),
  }),
)(EditInfoImageDialog);
